import type { Widget } from '@rjsf/utils';
import { useDebounceFn } from 'ahooks';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Select, { ISelectElement } from '@/components/core/Select';

import { useDictionaryControllerFindCountries } from '../../../../../api/generated/dictionaries/dictionaries';
import { Wrapper } from '../shared';

const Widget: Widget = ({ value, onChange, schema }) => {
	const [query, setQuery] = useState('');
	const { i18n } = useTranslation();

	const dictionary = Array.isArray(schema?.oneOf) ? schema.oneOf : [];

	const { data: options = [] } = useDictionaryControllerFindCountries(
		{
			query,
		},
		{
			query: {
				select: (data) => data.map(({ name, id }) => ({ label: name, value: id })),
				keepPreviousData: true,
				enabled: query.trim().length >= 2,
				queryKey: ['/v2/dictionaries/countries/find', query, i18n.language],
			},
		}
	);

	const selectedOption = useMemo(() => {
		if (!value) return undefined;

		const optionFromDictionary = dictionary.find(
			(el) => typeof el === 'object' && 'const' in el && el.const === value
		);

		if (optionFromDictionary && typeof optionFromDictionary === 'object')
			return {
				label: optionFromDictionary.title,
				value: optionFromDictionary.const as number,
			};

		return options.find((el) => el.value === value);
	}, [value, options, dictionary]);

	const { run: onInputChange } = useDebounceFn(setQuery, { wait: 300 });

	return (
		<div>
			<Select
				value={selectedOption}
				onInputChange={onInputChange}
				options={options}
				onChange={(option: ISelectElement) => onChange(option.value)}
			/>
		</div>
	);
};

const CountryWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	);
};

export { CountryWidget };
